import { render, staticRenderFns } from "./NewTodoItemType.vue?vue&type=template&id=2d6ea3a8"
import script from "./NewTodoItemType.vue?vue&type=script&lang=js"
export * from "./NewTodoItemType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports